<template lang="pug">
.waiter-family-list-tab(v-cloak)
  .mb-3
  .buttons.d-flex.flex-row.justify-content-end
    button.btn.all-delete-btn.mr-2(@click="showConfirmAllWaiterFamilyDeleteModal"
      :class="{ 'disable': items.length <= 0 }" :disabled="items.length <= 0") 全員削除
    button.btn.register-btn(@click="gotoWaiterFamilyRegister") メール利用の家族を追加
  .mb-2
  WaiterFamilyTable(
    v-model="items"
    :fields="fields"
    :totalRows.sync="rows"
    :currentPage="currentPage"
    :perPage="perPage"
    :isLoading="isLoading"
    @onEdit="gotoWaiterFamilyEdit"
    @onLineDelete="showConfirmWaiterFamilyDeleteModal"
    @onMailDelete="showConfirmMailWaiterFamilyDeleteModal"
    @onSendMessage="showTestMailModal"
  )
  .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
    // ページあたりの行数
    span.table-option-text 1ページの行数:
    .per-page
      b-form-select(
        id="per-page-select"
        v-model="perPage"
        :options="pageOptions"
        size="md"
        @change="selectPerPage"
      )
    // ページネーション
    b-pagination.m-0(
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      :disabled="isLoading"
      @change="selectPage"
      hide-goto-end-buttons
    )

  FamilyCheckAndMessageDeleteModal(
    v-model="showDeleteFamilyModal"
    :title="deleteMessage" :targetFacilities="concurrentDeleteFacilities"
    :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    @ok="deleteFamily()")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご家族はHitomeQコネクトの機能を使用できなくなります。
        li 削除後にご家族が再使用する場合は、再度ご家族にユーザー登録していただく必要があります。
  FamilyCheckDeleteModal(
    v-model="showDeleteMailFamilyModal"
    :title="deleteMessage" :targetFacilities="concurrentDeleteFacilities"
    @ok="deleteMailFamily()")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご家族はHitomeQコネクトからのメールを受信できなくなります。
        li 削除後に再使用する場合は、再度ユーザー登録していただく必要があります。
  FamilyCheckAndMessageDeleteModal(
    v-model="showDeleteAllFamilyModal"
    :title="deleteMessage" :targetFacilities="concurrentDeleteFacilities"
    :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    @ok="deleteAllFamily()")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li.error-message 全家族ユーザーを削除しようとしています。
        li 削除したご家族はHitomeQコネクトの機能使用できなくなる、またはメールを受信できなくなります。
        li 削除後に再使用する場合は、再度ユーザー登録していただく必要があります。
  OkModal(v-model="showDeleteSuccessModal" title="削除に成功しました。" @ok="createView")

  TestMailModal(v-model="testMailModalShow" :target.sync="testMailFamilyTargetName" :subject.sync="testMailSubject" :text.sync="testMailText"
    :targetType="1" :showValidationAlert.sync="showValidationAlert" @sendMail="confirmSendMail")
  TestMailConfirmModal(v-model="testMailConfirmModalShow" :target="testMailFamilyTargetName" :subject="testMailSubject" :text="testMailText" @sendMail="sendMail")
  OkModal(v-model="showSendMailSuccessModal" title="メールを送信しました。")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";

import { userStore } from "@/store/store";
import { tabIndexesStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import Setting from "../../../../public/setting.json";
import { PcUrl } from "@/commons/constants/PcUrl";

import FacilitiesService, { FacilityGetModel } from "@/commons/services/Facilities";
import WaitersService, { WaitersGetModel } from "@/commons/services/Waiters";
import { ResidentStatus } from "@/commons/services/Residents";
import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";
import MailFamiliesService from "@/commons/services/MailFamilies";
import SendMailMessagesService, { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import TestMailModal from "@/pc/components/modals/TestMailModal.vue";
import TestMailConfirmModal from "@/pc/components/modals/TestMailConfirmModal.vue";
import WaiterFamilyTable, { WaiterFamilyTableField, WaiterFamilyTableItem } from "@/pc/containers/waiters/WaiterFamilyTable.vue";
import FamilyCheckDeleteModal, { TargetFacility } from "@/pc/containers/waiters/FamilyCheckDeleteModal.vue";
import FamilyCheckAndMessageDeleteModal from "@/pc/containers/waiters/FamilyCheckAndMessageDeleteModal.vue";

/**
 * ### 家族ユーザータブコンポーネント
 */
@Component({
  components: {
    PageLoading,
    OkCancelModal,
    OkModal,
    TestMailModal,
    TestMailConfirmModal,
    WaiterFamilyTable,
    FamilyCheckDeleteModal,
    FamilyCheckAndMessageDeleteModal
  },
  $_veeValidate: { validator: "new" }
})
export default class WaiterFamilyListTab extends Vue {
  /** 施設サービス */
  @Inject("FacilitiesService") facilitiesService!: FacilitiesService;
  /** 待機者サービス */
  @Inject("WaitersService") waitersService!: WaitersService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 家族メールユーザーサービス */
  @Inject("MailFamiliesService") mailFamiliesService!: MailFamiliesService;
  /** メール送信サービス */
  @Inject("SendMailMessagesService") sendMailMessagesService!: SendMailMessagesService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** LINE家族削除確認モーダル表示可否 */
  showDeleteFamilyModal: boolean = false;
  /** MAIL家族削除確認モーダル表示可否 */
  showDeleteMailFamilyModal: boolean = false;
  /** 全家族削除確認モーダル表示可否 */
  showDeleteAllFamilyModal: boolean = false;
  /** 削除メッセージの送信可否 */
  sendDeleteMessage: boolean | null = null;
  /** 削除メッセージタイトル */
  deleteModalMessageTitle: string = "";
  /** 削除メッセージ本文 */
  deleteModalMessageText: string = "";

  /** 削除完了モーダル表示可否 */
  showDeleteSuccessModal: boolean = false;
  /** テストメール送信完了モーダル表示可否 */
  showSendMailSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 家族列名 */
  fields: Array<WaiterFamilyTableField> = [];
  /** 家族各行の情報 */
  items: Array<WaiterFamilyTableItem> = [];
  /** 読込み中か否か */
  isLoading: boolean = true;

  /** 削除対象の利用者ID */
  deleteTargetResidentId: number = 0;
  /** 削除対象の家族ID */
  deleteTargetFamilyId: number = 0;
  /** 削除対象の利用者システム一意ID */
  deleteTargetIdInSystem: number = 0;
  /** 削除モーダルに表示するメッセージ */
  deleteMessage: string = "";

  /** 同時削除する他施設の選択情報 */
  concurrentDeleteFacilities: Array<TargetFacility> = [];

  /** テストメールモーダルの表示状態 */
  testMailModalShow: boolean = false;
  /** テストメール宛先 */
  testMailTargetAddress: string = "";
  /** テストメール宛先ソートキー */
  testMailTargetSortKey: string = "";
  /** テストメール宛先家族名(実際には{部屋名}・{利用者名}様 のご家族 {家族名}（{続柄}）様と表示する) */
  testMailFamilyTargetName: string = "";
  /** テストメール宛先家族名 */
  testMailFamilyName: string = "";
  /** テストメール宛先利用者部屋名 */
  testMailResidentRoom: string = "";
  /** テストメール宛先利用者名 */
  testMailResidentName: string = "";
  /** テストメールタイトル */
  testMailSubject: string = "";
  /** テストメール本文 */
  testMailText: string = "";

  /** テストメール確認モーダルの表示状態 */
  testMailConfirmModalShow: boolean = false;

  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** 現在取得している件数 */
  currentRows: number = 0;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.waiter.waiterFamilyListTab.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.waiter.waiterFamilyListTab.pageOptions;

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  private setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `waiter-family-list-per-page=${perPage}; max-age=${saveSecond};`;

    return;
  }

  @Watch("sendDeleteMessage")
  changeSendDeleteMessage(sendDeleteMessage: boolean): void {
    this.setCookieForSendDeleteMessage(sendDeleteMessage);
    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  private setCookieForSendDeleteMessage(sendDeleteMessage: boolean): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `waiter-family-list-send-delete-message=${sendDeleteMessage}; max-age=${saveSecond};`;
    return;
  }

  /**
   * ### 画面情報をリフレッシュする
   *
   * - 親コンポーネントから呼び出される
   */
  public async refresh(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<WaiterFamilyTableField> = this.createFields();
    this.fields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.waiter.waiterFamilyListTab.perPage);
    // 削除時のメッセージ送信可否はCookieから取得する。取得出来ない場合はnull（未入力）を使用する
    const sendDeleteMessage: boolean | null = this.loadCookieForSendDeleteMessage();
    this.sendDeleteMessage = sendDeleteMessage != null ? sendDeleteMessage : null;

    // 動的に変更する画面情報を作成する
    this.items = [];
    this.currentRows = this.items.length;

    await this.createView();

    return;
  }

  /**
   * ### 列名を作成する
   */
  public createFields(): Array<WaiterFamilyTableField> {
    const fields: Array<WaiterFamilyTableField> = [];
    fields.push({ key: "senderType", label: "送信手段", sortable: false, sortDirection: "desc", class: "sender-type text-center" });
    fields.push({ key: "familyName", label: "家族ユーザー名", sortable: false, sortDirection: "desc", class: "family-name" });
    fields.push({ key: "familyRelation", label: "続柄", sortable: false, sortDirection: "desc", class: "family-relation" });
    fields.push({ key: "familyPosition", label: "役割", sortable: false, sortDirection: "desc", class: "family-position" });
    fields.push({ key: "familyTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "family-tel" });
    fields.push({ key: "operation", label: "登録情報", sortable: false, sortDirection: "desc", class: "operation text-center" });
    fields.push({ key: "sendMessage", label: "登録確認", sortable: false, sortDirection: "desc", class: "send-message text-center" });
    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  private loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["waiter-family-list-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  private loadCookieForSendDeleteMessage(): boolean | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      const sendDeleteMessage: string = cookieMap["waiter-family-list-send-delete-message"];
      if (sendDeleteMessage == "true") {
        return true;
      } else if (sendDeleteMessage == "false") {
        return false;
      } else {
        return null;
      }
    }

    return null;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    // 全体の行数を非同期で取得する
    const facilityId: number = Number(this.$route.params.facilityid);
    const residentId: number = Number(this.$route.params.residentid);
    const idInSystem: number = Number(this.$route.params.idinsystem);
    this.setRows(facilityId, residentId);

    const waiterViewableFacilities: Array<FacilityGetModel> = await this.getWaiterViewableFacilities();
    const waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = this.createWaiterViewableFacilitiesMap(waiterViewableFacilities);

    const waitersInSystem: Array<WaitersGetModel> = await this.getWaitersInSystem(idInSystem);
    const concurrentDeleteFacilities: Array<TargetFacility> = this.createConcurrentFacilities(waiterViewableFacilitiesMap, waitersInSystem);
    this.concurrentDeleteFacilities = concurrentDeleteFacilities;

    // 家族テーブルに渡す各プロパティを作成する
    const families: Array<FamilyGetModel> = await this.getFamilies(facilityId, residentId);
    const items: Array<WaiterFamilyTableItem> = this.createItems(families);
    this.items = items;
    this.currentRows = this.items.length;

    this.isLoading = false;

    return;
  }

  /**
   * ### ページング用の全件数を設定する
   */
  public async setRows(facilityId: number, residentId: number) {
    try {
      const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);
      this.rows = response.length;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }
    return;
  }

  /**
   * ### 閲覧可能施設を取得する
   */
  public async getWaiterViewableFacilities(): Promise<Array<FacilityGetModel>> {
    const facilities: Array<FacilityGetModel> = [];
    for (const facilityId of userStore.facility.waiterViewableFacilities) {
      const response: FacilityGetModel = await this.facilitiesService.get(userStore, { targetFacilityId: facilityId });
      facilities.push(response);
    }
    return facilities;
  }

  /**
   * ### 閲覧可能施設のMAPを作成する
   *
   * - Key:施設ID、Value:施設情報
   */
  public createWaiterViewableFacilitiesMap(facilities: Array<FacilityGetModel>): Map<number, FacilityGetModel> {
    const waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = new Map<number, FacilityGetModel>();
    for (const facility of facilities) {
      waiterViewableFacilitiesMap.set(facility.id, facility);
    }
    return waiterViewableFacilitiesMap;
  }

  /**
   * ### idInSystemが同じ他施設の待機者を取得する
   */
  public async getWaitersInSystem(residentIdInSystem: number): Promise<Array<WaitersGetModel>> {
    const response: Array<WaitersGetModel> = await this.waitersService.getsByIdInSystem(userStore, residentIdInSystem);
    return response;
  }

  /**
   * ### 同時に更新・削除する施設選択肢を作成する
   */
  public createConcurrentFacilities(viewableFacilityMap: Map<number, FacilityGetModel>, waitersInSystem: Array<WaitersGetModel>): Array<TargetFacility> {
    const targets: Array<TargetFacility> = [];

    for (const waiter of waitersInSystem) {
      if (waiter.status == ResidentStatus.RESIDENT) {
        continue;
      }
      const facility: FacilityGetModel | undefined = viewableFacilityMap.get(waiter.facilityId);
      targets.push({
        id: waiter.facilityId,
        residentId: waiter.id,
        name: facility ? facility.name : "",
        checked: false
      });
    }

    return targets;
  }

  /**
   * ### 家族を取得する
   *
   * - 家族は取得制限をしないためstartIndex、endIndexを指定しない
   */
  public async getFamilies(facilityId: number, residentId: number): Promise<Array<FamilyGetModel>> {
    const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);
    return response;
  }

  /**
   * ### 行を作成する
   */
  public createItems(families: Array<FamilyGetModel>): Array<WaiterFamilyTableItem> {
    let items: Array<WaiterFamilyTableItem> = [];

    for (const family of families) {
      items.push({
        id: family.id,
        residentsSortKey: family.residentsSortKey,
        residentName: family.name,
        familyId: family.familyId,
        familyName: family.familyName,
        familyRelation: family.familyRelation,
        familyPosition: family.familyPosition,
        familyMailaddress: family.familyMailaddress ? family.familyMailaddress : "",
        familyReplyFunction: family.familyPermittedFunctions.opinion,
        familyPictureFunction: family.familyPermittedFunctions.picture,
        familyTel: family.familyTel,
        senderType: family.senderType,
        updated: family.updated
      });
    }

    return items;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;

    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    return;
  }

  /**
   * ### 家族メールユーザー登録画面へ遷移する
   */
  public gotoWaiterFamilyRegister(): void {
    tabIndexesStore.setWaiterDetailTabIndex({ index: 3 });
    this.$router.push({
      name: PcUrl.WaiterFamilyRegister,
      params: { facilityid: this.$route.params.facilityid, residentid: this.$route.params.residentid, idinsystem: this.$route.params.idinsystem }
    });
    return;
  }

  /**
   * ### 家族メールユーザー編集画面へ遷移
   */
  public gotoWaiterFamilyEdit(family: WaiterFamilyTableItem): void {
    tabIndexesStore.setWaiterDetailTabIndex({ index: 3 });
    this.$router.push({
      name: PcUrl.WaiterFamilyEdit,
      params: { facilityid: this.$route.params.facilityid, residentid: this.$route.params.residentid, idinsystem: this.$route.params.idinsystem, familyid: `${family.familyId}` }
    });
    return;
  }

  /**
   * ### 家族ユーザー全削除確認モーダルを表示する
   *
   * - 削除メッセージを動的に作成する
   */
  public async showConfirmAllWaiterFamilyDeleteModal(): Promise<void> {
    if (this.items.length <= 0) {
      return;
    }
    this.deleteModalMessageTitle = "ユーザー登録が削除されました";
    const deleteMessages = [];
    deleteMessages.push(`ご利用の施設から${this.items[0].residentName}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
    deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
    this.deleteModalMessageText = deleteMessages.join("\n");

    this.deleteMessage = `${this.items[0].residentName}様のご家族全員を削除しますか？`;
    this.deleteTargetResidentId = Number(this.$route.params.residentid);
    this.deleteTargetIdInSystem = Number(this.$route.params.idinsystem);

    this.showDeleteAllFamilyModal = true;

    return;
  }

  /**
   * ### 全家族ユーザーを削除する
   */
  public async deleteAllFamily(): Promise<void> {
    this.showDeleteAllFamilyModal = false;
    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    this.$emit("onDeleteAllFamily", {
      residentId: this.deleteTargetResidentId,
      families: this.items,
      concurrentDeleteFacilityIds,
      deleteModalMessageTitle: this.deleteModalMessageTitle ? this.deleteModalMessageTitle : "",
      deleteModalMessageText: this.deleteModalMessageText ? this.deleteModalMessageText : ""
    });
    return;
  }

  /**
   * ### 家族ユーザー削除確認モーダルを表示する
   *
   * - 削除メッセージを動的に作成する
   */
  public showConfirmWaiterFamilyDeleteModal(family: WaiterFamilyTableItem): void {
    this.deleteModalMessageTitle = "ユーザー登録が削除されました";
    const deleteMessages = [];
    deleteMessages.push(`ご利用の施設から${family.familyName}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
    deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
    this.deleteModalMessageText = deleteMessages.join("\n");

    const residentName: string = family.residentName ? family.residentName : "";
    const familyName: string = family.familyName ? family.familyName : "";
    const familyRelation: string = family.familyRelation ? `（${family.familyRelation}）` : "";
    this.deleteMessage = `${residentName}様のご家族${familyName}${familyRelation}様を削除しますか？`;
    this.deleteTargetResidentId = family.id;
    this.deleteTargetFamilyId = family.familyId;

    this.showDeleteFamilyModal = true;

    return;
  }

  /**
   * ### 家族ユーザーを削除する
   */
  public async deleteFamily(): Promise<void> {
    this.showDeleteFamilyModal = false;
    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    this.$emit("onDeleteLineFamily", {
      residentId: this.deleteTargetResidentId,
      familyId: this.deleteTargetFamilyId,
      concurrentDeleteFacilityIds,
      deleteModalMessageTitle: this.deleteModalMessageTitle ? this.deleteModalMessageTitle : "",
      deleteModalMessageText: this.deleteModalMessageText ? this.deleteModalMessageText : ""
    });
    return;
  }

  /**
   * ### 家族メールユーザー削除確認モーダルを表示する
   */
  public showConfirmMailWaiterFamilyDeleteModal(family: WaiterFamilyTableItem): void {
    // 削除メッセージを動的に作成する
    const residentName: string = family.residentName ? family.residentName : "";
    const familyName: string = family.familyName ? family.familyName : "";
    const familyRelation: string = family.familyRelation ? `（${family.familyRelation}）` : "";
    this.deleteMessage = `${residentName} 様のご家族 ${familyName}${familyRelation}様を削除しますか？`;
    this.showDeleteMailFamilyModal = true;

    this.deleteTargetResidentId = family.id;
    this.deleteTargetFamilyId = family.familyId;

    return;
  }

  /**
   * ### 家族メールユーザーを削除する
   */
  public async deleteMailFamily(): Promise<void> {
    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    this.$emit("onDeleteMailFamily", { residentId: this.deleteTargetResidentId, familyId: this.deleteTargetFamilyId, concurrentDeleteFacilityIds });
    return;
  }

  /**
   * ### テストメール送信モーダルを表示する
   *
   * - テストメール送信モーダルに必要な情報を作成する
   * - モーダルを表示する
   */
  public showTestMailModal(family: WaiterFamilyTableItem): void {
    this.testMailTargetAddress = family.familyMailaddress ? family.familyMailaddress : "";
    this.testMailTargetSortKey = family.residentsSortKey;
    this.testMailFamilyTargetName = `${family.residentName}様 のご家族 ${family.familyName}（${family.familyRelation}）様`;
    this.testMailFamilyName = `${family.familyName}`;
    this.testMailResidentName = `${family.residentName}`;
    this.testMailSubject = "HitomeQコネクト登録確認メール";
    this.testMailText =
      "HitomeQコネクトのメール配信サービスへのお申し込みありがとうございます。\n" +
      "お申し込みのメールアドレスを登録致しました。\n" +
      "後ほど受信確認のご連絡をさせていただきます。\n\n" +
      "もしお心当たりの無い場合は、本メールを削除してください。";

    this.testMailModalShow = true;

    return;
  }

  /**
   * ### テストメール送信確認モーダルを表示する
   *
   * - テストメールの内容をバリデーションする
   * - バリデーションで問題が無ければテストメール確認モーダルを表示する
   */
  public async confirmSendMail(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.testMailConfirmModalShow = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### テストメールを送信する
   *
   * - メールを送信するのでテストメールモーダル、テストメール確認モーダルを非表示にする
   * - メール送信用のパラメータを作成する
   * - メールを送信する
   */
  public async sendMail(): Promise<void> {
    this.testMailModalShow = false;
    this.testMailConfirmModalShow = false;

    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const sendMailMessage: SendMailMessagesPostModel = this.createSendMailMessageModel();
    await this.sendMailMessagesService.post(userStore, sendMailMessage);

    // 送信成功ダイアログを表示する
    this.showSendMailSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### メール送信用パラメータを作成する
   */
  public createSendMailMessageModel(): SendMailMessagesPostModel {
    const sendMailMessage: SendMailMessagesPostModel = {
      sortKeys: [this.testMailTargetSortKey],
      targetName: `${this.testMailFamilyName}`,
      subject: this.$stringUtil.convertYen(this.testMailSubject),
      text: this.$stringUtil.convertYen(this.testMailText),
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      // メッセージ送信画面でしか使用しないので以下は空相当の情報を格納する
      type: "",
      addOptionText: false,
      addReadButton: false,
      addReplyButton: false,
      fileUrls: [],
      fileNames: [],
      addReceivedMessageUrl: false,
      needDbRegister: false
    };

    return sendMailMessage;
  }
}
</script>

<style lang="scss" scoped>
.waiter-family-list-tab {
  position: relative;
}
</style>
